import { gql } from '@apollo/client';

export const deletePart = gql`
  mutation deletePart($id: String) {
    deletePart(id: $id)
  }
`;
